module.exports = __webpack_public_path__ + "static/media/webshop.0f9ff808.png";